/**
 * pdf domain — /pdf/generate, /pdf/generate-package.
 * PuppeteerSharp + local Chromium — cold start 60-90s, 503 if not warm.
 */

import type {
  RequestOptions,
  PdfGenerateRequest,
  PdfGenerateResult,
  PdfGeneratePackageRequest,
  PdfGeneratePackageResult,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class PdfApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public generate(req: PdfGenerateRequest, opts?: RequestOptions): Promise<PdfGenerateResult> {
    return this.http.post<PdfGenerateResult>('/pdf/generate', { ...opts, body: req });
  }

  public generatePackage(
    req: PdfGeneratePackageRequest,
    opts?: RequestOptions
  ): Promise<PdfGeneratePackageResult> {
    return this.http.post<PdfGeneratePackageResult>('/pdf/generate-package', { ...opts, body: req });
  }
}
